import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router';

import { checkVersionAndReload } from '../../utils/version';
import { isWebView } from '../../utils/base';
import { useInterval } from '../../actions/interval';

const VERSION_CHECK_INTERVAL = process.env.REACT_APP_VERSION_CHECK_INTERVAL
    ? parseInt(process.env.REACT_APP_VERSION_CHECK_INTERVAL)
    : 600000; // 10분 (600초)

export const VersionChecker = () => {
    const location = useLocation();
    const [shouldCheckVersion, setShouldCheckVersion] = useState(false);

    useEffect(() => {
        // 버전 체크 시작
        // 웹뷰가 있는 경우에만 버전 체크를 수행
        const appType = localStorage.getItem('appType');
        if (appType && isWebView()) {
            // 즉시 한 번 체크
            checkVersionAndReload();
            // 주기적 체크 활성화
            setShouldCheckVersion(true);
        } else {
            setShouldCheckVersion(false);
        }
    }, []);

    useEffect(() => {
        // 페이지 이동 시 버전 체크 수행
        // admin 앱 타입일 때만 실행
        const appType = localStorage.getItem('appType');
        if (appType && appType === 'admin') {
            checkVersionAndReload();
        }
    }, [location.pathname]);

    // 주기적 버전 체크 (useInterval 사용)
    useInterval(() => {
        if (shouldCheckVersion) {
            checkVersionAndReload();
        }
    }, shouldCheckVersion ? VERSION_CHECK_INTERVAL : null);

    return null;
};
